import type { JSX } from 'react';
import { create } from 'zustand';

type ComponentStore = Record<string, undefined | (() => JSX.Element)>;

export const useComponentStore = create<ComponentStore>(() => ({}));
